import _ from 'lodash';

export function separateArr(callbackFn, xs) {
  return xs.reduce(
    ([T, F], x, i, arr) => {
      if (callbackFn(x, i, arr) === false) return [T, [...F, x]];
      else return [[...T, x], F];
    },
    [[], []]
  );
}

export function randomEleInArray(array, ...ele): string {
  let arrRandom;
  if (ele) {
    const eleArray = [...ele];
    arrRandom = _.difference(array, eleArray);
  } else {
    arrRandom = array;
  }

  return arrRandom[Math.floor(Math.random() * arrRandom.length)];
}

export function removeEleDuplicateInArray(array: any[]): any[] {
  const s = new Set(array);
  const it = s.values();
  return Array.from(it);
}

type EnumType = { [key: string]: string | number };
type EnumAsArrayType = {
  key: string;
  value: any;
}[];
export const enumToArray = (data: EnumType): EnumAsArrayType =>
  Object.keys(data)
    .filter(key => Number.isNaN(+key))
    .map((key: string) => ({
      key,
      value: data[key],
    }));

export function shuffle(array: any[]): any[] {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
}

export function isNullOrEmptyArray(array?: any[]): boolean {
  return !array || array.length === 0;
}

export function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
}
